import Pagination, { Props as ImportedProps } from './Pagination';
import { Props as ImportedSwitcherProps } from './Switcher';
import { Props as ImportedResultTextProps } from './ResultText';

export type Props = ImportedProps;
export type SwitcherProps = ImportedSwitcherProps;
export type ResultTextProps = ImportedResultTextProps;
export default Pagination;
